import { render, staticRenderFns } from "./noodKenF.vue?vue&type=template&id=9cc33d48&scoped=true"
import script from "./noodKenF.vue?vue&type=script&lang=js"
export * from "./noodKenF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc33d48",
  null
  
)

export default component.exports